import { useTranslation } from "react-i18next";
import { useCreateActivityDraft } from "../../hooks/useActivities";
import { Activity, CreateActivityRequest } from "../../models/Activity";
import { Field } from "../../models/Field";
import { validateExistingItemForRequest } from "../../services/FieldService";
import { ClientRoutes } from "../../models/ClientRoutes";
import { useNavigate } from "react-router-dom";
import { ButtonWithLoading } from "../ButtonWithLoading";

interface CreateDraftButtonProps {
  activity: Activity;
  activityFields: Field[];
}

export const CreateMirroredActivityButton = (props: CreateDraftButtonProps) => {
  const { activity, activityFields } = props;
  const { mutateAsync: createActivityDraft, isPending: createDraftPending } =
    useCreateActivityDraft();

  const { t } = useTranslation();

  const navigate = useNavigate();

  async function onCreateDraftClick() {
    if (!activity || !activity.activityId || !activityFields) {
      return;
    }

    const requestFields = validateExistingItemForRequest(
      activity.fieldValues,
      activityFields
    );

    const createRequest: CreateActivityRequest = {
      title: activity.title,
      serializedHtml: activity?.description?.serializedHtml
        ? activity.description.serializedHtml
        : "",
      fieldsWithValues: requestFields,
      toolIds: activity.toolIds,
      mirroredActivityId: activity.activityId,
      processFlowSettings: activity.processFlowSettings,
    };

    const createdActivity = await createActivityDraft(createRequest);

    navigate(`${ClientRoutes.Activities}/${createdActivity.versionId}`);
  }

  return (
    <ButtonWithLoading
      onClick={onCreateDraftClick}
      isLoading={createDraftPending}
      text={t("mirrorActivity")}
      disabled={!activity || !activity.activityId}
    />
  );
};
